<template>
  <LoadingIndicator>
    <b-modal :title="$t('msg.agreementWarning')" v-model="isAgreementInvalid" ok-only>
      <div class="text-sm-left" id="up">
        {{ $t("route.contractExpired") }}
      </div>
    </b-modal>
  
    <b-modal :title="$t('msg.agreementWarning')" v-model="isAgreementMissing" ok-only>
      <div class="text-sm-left" id="up">
        {{ $t("route.noContract") }}
      </div>
    </b-modal>
  
    <div class="mt-1">
      <b-container fluid>
        <b-row>
          <b-col order="4" order-lg="0" lg="4">
            <b-tabs card v-model="tabIndexProvider" small class="compact-tabs">
              <b-tab title="Primar">
                <b-tabs v-model="tabIndexService" small class="compact-tabs">
                  <b-tab title="S-63">
                    <orders-table ref="order-tab" :parent-methods="this"
                      @on-cell-clicked-orders-table="onCellClickedOrdersTable"
                      @on-cell-clicked-complex-orders-table="onCellClickedComplexOrdersTable"
                      @on-replace-cell-orders-table="onReplaceCellOrdersTable" />
                  </b-tab>
                  <b-tab title="S-102">
                    <NoService />
                  </b-tab>
                  <b-tab title="Navarea">
                    <NoService />
                  </b-tab>
                </b-tabs>
              </b-tab>
            </b-tabs>
          </b-col>
  
          <b-col>
            <b-row>
              <b-col class="text-left">
                <div class="d-flex align-items-center">
                  <div class="ship-badge">
                    <!-- <i class="fas fa-ship mr-2" /> -->
                    <span>{{ getShipName }}</span>
                  </div>
                  <!-- <b-form-select
                                                                                    v-model="selected_ship"
                                                                                    :options="ships"
                                                                                    disabled="true"
                                                                                    :title="getSelectedShipTooltip"
                                                                                    v-b-tooltip.hover
                                                                                    size="sm"
                                                                                    style="max-width: 200px; min-width: 120px; width: 200px; margin-left: auto; display: block"
                                                                                  /> -->
                  <!-- <span class="ml-2 small-gray">{{ deviceStore.getAgreementProvider }}</span> -->
                </div>
              </b-col>
              <b-col>
                <!-- <Breadcrumbs :items="breadcrumbItems" /> -->
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                <div>
                  <orders-map ref="orders-map" :height="map_size" />
                </div>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
      </b-container>
    </div>
  </LoadingIndicator>
</template>

<script>
import { useMomentaryStore } from "@/stores/momentary";
import OrdersMap from "@/views/orders/OrdersMap.vue";
import { eventBus } from "@/main";
import { mapStores } from "pinia";
import OrdersTable from "@/views/orders/OrdersTable.vue";
import LoadingIndicator from "@/components/LoadingIndicator.vue";
import Breadcrumbs from "@/components/Breadcrumbs.vue";
import { myAxios } from "@/services/myAxios";
import dayjs from "dayjs";
import { useUserStore } from "@/stores/user";
import { useDeviceStore } from "@/stores/device";
import { loadAgreements, loadShips, prepareCatalog } from "@/helpers/api";
import i18n from "@/i18n";
import { setTimeout } from "core-js";
import NoService from "@/views/orders/NoService.vue";


export default {
  components: {
    OrdersMap: OrdersMap,
    OrdersTable: OrdersTable,
    LoadingIndicator,
    Breadcrumbs,
    NoService,
  },
  data() {
    return {

      selected_ship: "",
      ships: [],

      windowWidth: window.innerWidth,

      editMode: false,
      editItems: [],
      orderId: "",

      tabIndexProvider: 0,
      tabIndexService: 0,

      catalogTimer: null,
    };
  },
  mounted() {
    myAxios.get("/api/v1/manage/test");

    window.addEventListener("resize", this.handleResize);

    // Проверяем, выбран ли корабль
    this.checkShipSelection();

    eventBus.$on("toggle-listed-highlights", (mode) => {
      if (this.$refs["orders-map"]) {
        this.$refs["orders-map"].toggleHighlightsVisibility(mode);
      }
    });

    loadShips().then(() => {
      loadAgreements().then(() => {
        // Запускаем критичную загрузку каталога
        this.momentaryStore.startCriticalLoading("catalog-preparation", this.$t("route.loadingCatalog"));

        if (this.deviceStore.isDeviceIDExist) this.selected_ship = this.deviceStore.getDeviceID;
        else this.selected_ship = this.userStore.getECDISShips[0]?.value ?? "";

        this.ships = this.userStore.getECDISShips;

        this.catalogTimer = setTimeout(() => {
          prepareCatalog()
            .then(() => {
              // Останавливаем критичную загрузку каталога
              this.momentaryStore.stopCriticalLoading("catalog-preparation");
              this.is_items_by_route_preparing = false;

              this.$refs["orders-map"].init_map().then(() => {
                this.is_items_by_route_preparing = false;
              });
            })
            .catch((error) => {
              // Останавливаем загрузку в случае ошибки
              this.momentaryStore.stopCriticalLoading("catalog-preparation");
              console.error("Error preparing catalog:", error);
            });
        }, 2000); // TODO: убрать таймаут
      });
    });
  },
  watch: {
    selected_ship(newVal, oldVal) {
      this.deviceStore.selectDevice(newVal);

      // // Если корабль изменился, перезагружаем страницу
      // if (oldVal && newVal && oldVal !== newVal) {
      //   window.location.reload();
      //   return;
      // }

      this.deviceStore.selectDevice(newVal);

      // TODO
      this.$refs["order-tab"].getHistory().then((resp) => {
        if (this.deviceStore.getAgreementProvider === "UKHO") this.deviceStore.addOrdersHistoryAVCS(resp.avcsCells);
        else if (this.deviceStore.getAgreementProvider === "Primar" || this.deviceStore.getAgreementID === "-1") {
          const historyMap = new Map();
          resp.orders.forEach((order) => {
            const date = order.createdUtc;
            const status = order.status;

            if (status === "complete") {
              order.items.forEach((item) => {
                const name = item.id;
                let period = null;
                
                // Преобразуем дату в формат YYYY-MM-DD
                if (date) {
                  try {
                    period = dayjs(date).add(item.monthCount, 'months').format("YYYY-MM-DD");
                  } catch (e) {
                    console.warn('[Orders] watch handler: ошибка при обработке даты:', date, e);
                  }
                }

                const existing = historyMap.get(name);
                if (!existing || (period && dayjs(period).isAfter(dayjs(existing.expiryDate)))) {
                  historyMap.set(name, { name, expiryDate: period || 'Unknown' });
                }
              });
            }
          });
          this.deviceStore.addOrdersHistoryPrimar(Array.from(historyMap.values()));
        }
      });
    },
  },
  computed: {
    breadcrumbItems() {
      const items = [this.$t("menu.folio")]; // "Folio"

      items.push(this.$t("menu.orders")); // "Orders"

      // Определяем провайдера и сервисы
      if (this.tabIndexProvider === 0) {
        // Primar
        items.push("Primar");

        if (this.tabIndexService === 0) {
          items.push("S-63");
        } else if (this.tabIndexService === 1) {
          items.push("S-102");
        } else if (this.tabIndexService === 2) {
          items.push("Navarea");
        }
      } else if (this.tabIndexProvider === 1) {
        // UKHO
        items.push("UKHO");
      }

      return items;
    },

    dayjs() {
      return dayjs;
    },
    // getSelectedShipTooltip() {
    //   let tooltip = "";
    //   if (this.$store.state.auth.user.role === "distributor") {
    //     let deviceId = this.selected_ship;
    //     let ship = this.ships.find((e) => e.value === deviceId);
    //     tooltip = ship?.email + ", " + deviceId;
    //   }
    //   return tooltip;
    // },

    // Название корабля
    getShipName() {
      if (this.selected_ship === "") return "";
      const ship = this.ships.find((e) => e.value === this.selected_ship);
      return ship ? ship.text : "";
    },

    isAgreementInvalid() {
      return false
      if (!this.deviceStore.isAgreementLoaded || this.deviceStore.getDeviceID === "") return false;
      else if (this.deviceStore.isAgreementLoaded && this.deviceStore.isDeviceInAgreement(this.deviceStore.getDeviceID) && !this.deviceStore.isAgreementValid(this.deviceStore.getDeviceID))
        return true;
      else return false;
    },

    isAgreementMissing() {
      return false
      if (!this.deviceStore.isAgreementLoaded || this.deviceStore.getDeviceID === "") return false;
      else if (this.deviceStore.isAgreementLoaded && !this.deviceStore.isDeviceInAgreement(this.deviceStore.getDeviceID)) return true;
      else return false;
    },

    ...mapStores(useMomentaryStore, useUserStore, useDeviceStore),

    is_mobile() {
      return this.windowWidth <= 760;
    },
    map_size() {
      if (this.is_mobile) return window.innerHeight / 1.8;
      else return window.innerHeight / 1.2;
    },
  },

  created() {
  },

  beforeDestroy() {
    // Генерируем событие для очистки внешних ресурсов (графики, наблюдатели и т.д.)
    eventBus.$emit('beforeDestroy');

    if (this.map) {
      this.map.destroy();
      this.map = null;
    }

    window.removeEventListener("resize", this.handleResize);
    eventBus.$off("toggle-listed-highlights");
    if (this.catalogTimer) {
      clearTimeout(this.catalogTimer);
      this.catalogTimer = null;
    }
  },

  methods: {
    handleResize() {
      this.windowWidth = window.innerWidth;
    },
    // Проверка выбора корабля при загрузке страницы
    checkShipSelection() {
      console.log('Checking ship selection, appType:', this.deviceStore.getShipName);
      
      if (this.deviceStore.getShipName === "") {
        console.log('Ship not selected, showing dialog');
        
        this.$bvModal.msgBoxOk(
          'Please select a ship first to continue',
          {
            size: 'sm',
            buttonSize: 'sm',
            okVariant: 'primary',
            okTitle: 'Select',
            centered: true,
            hideHeader: true,
            bodyClass: 'text-center p-4',
            footerClass: 'justify-content-center border-0 pt-2 pb-3',
            modalClass: 'ship-selection-modal'
          }
        ).then(() => {
          console.log('Redirecting to home page');
          this.$router.push({ name: 'home' });
        }).catch((error) => {
          console.error('Error in ship selection dialog:', error);
          // В случае ошибки всё равно перенаправляем на главную
          this.$router.push({ name: 'home' });
        });
      }
    },

    onCellClickedOrdersTable(id) {
      this.$refs["orders-map"].ordersTableMethods("onCellClickedOrdersTable", id);
    },
    onCellClickedComplexOrdersTable(id) {
      this.$refs["orders-map"].ordersTableMethods("onCellClickedComplexOrdersTable", id);
    },
    onReplaceCellOrdersTable(id) {
      this.$refs["orders-map"].ordersTableMethods("onReplaceCellOrdersTable", id);
    },
    redraw() {
      if (this.$refs["orders-map"] && this.$refs["orders-map"].redraw) {
        this.$refs["orders-map"].redraw();
      }
    },
  }
};
</script>

<style scoped>
:deep(.compact-tabs .nav-tabs) {
  border-bottom: 1px solid #d1d9e6;
  display: flex;
  flex-wrap: wrap;
  overflow-x: visible;
  overflow-y: visible;
  scrollbar-width: thin;
  padding: 0.15rem 0.15rem 0;
}

:deep(.compact-tabs .nav-tabs .nav-item) {
  margin-bottom: 3px;
  white-space: nowrap;
  flex: 0 0 auto;
  margin-right: 1px;
}

:deep(.compact-tabs .nav-link) {
  padding: 0.3rem 0.6rem;
  font-size: 0.8rem;
  border-radius: 0.4rem 0.4rem 0 0;
  transition: all 0.2s ease;
  border: 1px solid #e9ecef;
  border-bottom: none;
  color: #5a6a85;
}

:deep(.compact-tabs .nav-link:hover:not(.active)) {
  background-color: rgba(108, 117, 125, 0.08);
  border-color: #e2e8f0;
  color: #495057;
}

:deep(.compact-tabs .nav-link.active) {
  background-color: #f8f9fa;
  background-image: linear-gradient(to bottom, #ffffff, #f8f9fa);
  border-color: #d1d9e6;
  color: #3a3f51;
  font-weight: 500;
  box-shadow: 0 -2px 5px rgba(0, 0, 0, 0.03);
}

:deep(.compact-tabs .tab-content) {
  border: 1px solid #d1d9e6;
  border-top: none;
  padding: 0.75rem 0.2rem;
  border-bottom-left-radius: 0.25rem;
  border-bottom-right-radius: 0.25rem;
  background-color: #ffffff;
}

/* Hide scrollbar for Chrome/Safari */
:deep(.compact-tabs .nav-tabs::-webkit-scrollbar) {
  height: 3px;
  width: 0;
}

:deep(.compact-tabs .nav-tabs::-webkit-scrollbar-thumb) {
  background: rgba(108, 117, 125, 0.2);
  border-radius: 3px;
}

:deep(.tab-content)>.tab-pane {
  padding: 0;
}

:deep(.compact-tabs .tab-pane) {
  padding-top: 0.5rem;
}

:deep(.compact-tabs) {
  margin-top: 0.2rem !important;
}

.ship-badge {
  background: #f5f6fa;
  border-radius: 6px;
  padding: 4px 12px;
  display: flex;
  align-items: center;
  color: #000000;
  font-size: 0.9em;
  min-width: 90px;
  min-height: 35px;
  font-weight: 700;
}

/* Минимальные стили для модального окна */
:deep(.ship-selection-modal .modal-content) {
  border-radius: 8px;
}


</style>
